export function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

  if (typeof document !== "undefined") {
    arr = document.cookie.match(reg);
    if (arr) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  } else {
    return null;
  }
  // if (typeof document !== "undefined" && arr === document.cookie.match(reg)) return unescape(arr[2]);
  // else return null;
}

export function setCookie(name, value) {
  var Days = 1;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie =
    name +
    "=" +
    escape(value) +
    ";expires=" +
    exp.toGMTString() +
    ";path=/" +
    ";domain=.authing.cn";
}
